"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunitySchema = exports.ItemPurchaseRecurrenceOpportunitySchema = exports.CrossSellOpportunitySchema = exports.ItemSuggestionSchema = exports.DelayedRecurrenceOpportunitySchema = exports.BirthdayOpportunitySchema = exports.BaseOpportunitySchema = exports.OpportunityType = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
var OpportunityType;
(function (OpportunityType) {
    OpportunityType["Birthday"] = "BIRTHDAY";
    OpportunityType["CrossSell"] = "CROSS_SELL";
    OpportunityType["DelayedRecurrence"] = "DELAYED_RECURRENCE";
    OpportunityType["ItemPurchaseRecurrence"] = "ITEM_PURCHASE_RECURRENCE";
})(OpportunityType || (exports.OpportunityType = OpportunityType = {}));
exports.BaseOpportunitySchema = zod_1.z.object({
    type: zod_1.z.nativeEnum(OpportunityType),
    evaluatedAt: zod_1.z.coerce.date(),
    expiresAt: zod_1.z.coerce.date().optional(),
});
exports.BirthdayOpportunitySchema = exports.BaseOpportunitySchema.extend({
    type: zod_1.z.literal(OpportunityType.Birthday),
    nearestBirthday: zod_1.z.coerce.date(),
});
exports.DelayedRecurrenceOpportunitySchema = exports.BaseOpportunitySchema.extend({
    type: zod_1.z.literal(OpportunityType.DelayedRecurrence),
    recurrenceWindowStartsAt: zod_1.z.coerce.date(),
});
exports.ItemSuggestionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    coverPictureUrl: zod_1.z.string().url().optional(),
    reason: zod_1.z.string().optional(),
});
exports.CrossSellOpportunitySchema = exports.BaseOpportunitySchema.extend({
    type: zod_1.z.literal(OpportunityType.CrossSell),
    triggerItem: exports.ItemSuggestionSchema,
    suggestedItems: zod_1.z.array(exports.ItemSuggestionSchema).min(1),
});
exports.ItemPurchaseRecurrenceOpportunitySchema = exports.BaseOpportunitySchema.extend({
    type: zod_1.z.literal(OpportunityType.ItemPurchaseRecurrence),
    triggerItem: exports.ItemSuggestionSchema.omit({ reason: true }).extend({
        recurrence: zod_1.z.nativeEnum(enums_1.PurchaseRecurrence),
    }),
    /**
     * The date when the recurrence window begins. The calculation is performed three days before the expiration date.
     */
    recurrenceWindowStartsAt: zod_1.z.coerce.date(),
});
exports.OpportunitySchema = zod_1.z.discriminatedUnion('type', [
    exports.BirthdayOpportunitySchema,
    exports.CrossSellOpportunitySchema,
    exports.DelayedRecurrenceOpportunitySchema,
    exports.ItemPurchaseRecurrenceOpportunitySchema,
]);
//# sourceMappingURL=opportunity.js.map